<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:20px;width:100%;box-sizing: border-box;">
      <el-button size="small" @click="back" icon="el-icon-arrow-left" class="back">返回</el-button>
      <el-row class="mt2" type="flex" justify="center" style="background:#fff;padding:35px 0 20px 0;">
        <el-col :span="8" style="position: relative;">
          <el-steps :active="active" process-status="success" :align-center="true">
            <el-step title="退款审核中"></el-step>
            <el-step title="待退款"></el-step>
            <el-step title="已取消"></el-step>
          </el-steps>
          <img v-if="form.extOrderId" style="position: absolute; top: -35px; right: -60px;" :src="customerOrder.isLocked ? locked : unlocked" width="80px" height="80px" alt="">
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="space-between">
        <el-col :span="17">
          <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="120px">
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width:150px">
                车辆信息<span @click="toCustomer" style="color:#409EFF" v-if="formName != 'customerDetail'"
                  class="toCustomer">客户详情</span>
              </div>
              <el-form-item class="form_item" label-width="260px" v-if="form.extOrderId != ''"
                :label="'销售订单号:' + form.extOrderId">
              </el-form-item>
            </el-row>
            <el-row style="background:#fff;padding:15px 0;">
              <el-form-item class="form_item" label="订单类型" prop="orderType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  v-model="form.orderType">
                  <el-option v-for="item in orderTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订购车型" prop="modelId">
                <el-cascader size="mini" class="filter-item" :disabled="disabled" style="width: 330px;"
                  placeholder="选择订购车型" filterable :show-all-levels="true" :options="carOptions" v-model="form.modelId"
                  @change="changeSpecColor"></el-cascader>
              </el-form-item>
              <el-form-item class="form_item" label="车辆状态" v-if="form.otdStatus != ''">
                <div style="width:160px;">{{ form.otdStatus }}</div>
              </el-form-item>
              <el-form-item class="form_item" label="外观颜色" prop="modelColor">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  v-model="form.modelColor" @change="modelColorChange">
                  <el-option v-for="(item, index) in colors" :key="index" :label="item.color + '(' + item.total + ')'"
                    :value="item.color"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="内饰">
                <el-select size="mini" :disabled="disabled" style="width:160px;" placeholder="请选择"
                  v-model="form.carInternalColor" @change="carInternalColorChange">
                  <el-option v-for="(item, index) in carInternalColor" :key="index" :label="item === '' ? '无' : item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-for="(options, key) in carModelOptionalsComputed" :key="key" class="form_item" :label="modelOptionalsKeyMap.get(key)">
                <el-select
                  size="mini"
                  :disabled="disabled"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carModelOptionals[key]"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item === '无选装' ? '' : item"
                    :label="item === '' ? '无' : item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订金" prop="paymentDown">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model="form.paymentDown"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="收款方式" prop="payType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择" v-model="form.payType">
                  <el-option label="全款" :value="1"></el-option>
                  <el-option label="按揭" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="预计交车时间">
                <el-date-picker size="mini" style="width:160px;" :disabled="disabled" :picker-options="pickerOptions"
                  v-model="form.deliverDate" :clearable="false" type="date" value-format="timestamp" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="form_item" label="订车原因">
                <el-select size="mini" style="width:200px;" placeholder="请选择" :disabled="disabled"
                  v-model="form.orderReason" multiple>
                  <el-option v-for="(item, index) in failProductReasonDics" :key="index" :label="item.dataName"
                    :value="item.dataName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="对比车型">
                <el-select size="mini" style="width:250px;" placeholder="请选择" :disabled="disabled"
                  v-model="form.competeSeriesId">
                  <el-option v-for="(item, index) in competitionSeries" :key="index"
                    :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="购车类型" prop="businessType">
                <el-select size="mini" style="width:160px;" placeholder="请选择" :disabled="disabled"
                  v-model="form.businessType">
                  <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:10px">
              <div class="title">客户信息</div>
            </el-row>
            <el-row style="background:#fff;padding:15px 0;">
              <el-form-item class="form_item" label="类型" prop="customerType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  @change="customerTypeChange" v-model="form.customerType">
                  <el-option label="个人" :value="1"></el-option>
                  <el-option label="企业" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" :label="form.customerType === 1 ? '订车人姓名' : '公司名称'" prop="customerName">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model.trim="form.customerName"
                  onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="联系电话" prop="customerPhone">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model="form.customerPhone"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="证件类型" prop="identifyType">
                <el-select size="mini" :disabled="disabled" @change="identifyTypeChange" style="width:160px;"
                  placeholder="请选择" v-model="form.identifyType">
                  <el-option v-for="item in orderIdentifyTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType === 1" label="证件号码" prop="identifyNo">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()" v-model.trim="form.identifyNo"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType === 2" label="证件号码" prop="identifyNo2">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model.trim="form.identifyNo2" onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType === 3" label="证件号码" prop="identifyNo3">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model.trim="form.identifyNo3" onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType != 1 &&
                form.identifyType != 2 &&
                form.identifyType != 3
                " label="证件号码" prop="identifyNos">
                <el-input size="mini" style="width: 160px;" :disabled="disabled" placeholder="请输入"
                  v-model.trim="form.identifyNos" onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="推荐人姓名" prop="referrerName">
                <el-input size="mini" disabled style="width: 160px;" placeholder="请输入"
                  v-model="form.referrerName"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="推荐人电话" prop="referrerPhone">
                <el-input size="mini" disabled style="width: 160px;" placeholder="请输入"
                  v-model="form.referrerPhone"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="省/市/区">
                <el-select size="mini" :disabled="disabled" style="width:100px;" placeholder="选择省" clearable
                  @change="provinceChange" v-model="form.customerProvince">
                  <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select size="mini" style="width:100px;" :disabled="disabled" placeholder="选择市" clearable
                  @change="cityChange" v-model="form.customerCity">
                  <el-option v-for="item in citys" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select size="mini" style="width:100px;" :disabled="disabled" placeholder="选择区" clearable
                  v-model="form.customerCounty">
                  <el-option v-for="item in countys" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="详细地址" prop="customerAddress">
                <el-input size="mini" :disabled="disabled" style="width: 300px;" placeholder="请输入"
                  v-model="form.customerAddress"></el-input>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:10px">
              <div class="title">其他信息</div>
              <el-row style="background:#fff;padding:15px 0;">
                <el-form-item class="form_item" label="成交渠道">
                  <el-input v-if="form.reactivateSource" size="mini" style="width: 160px;" v-model="form.reactivateSource" disabled></el-input>
                  <el-input v-else size="mini" style="width: 160px;" v-model="form.sourceName" disabled></el-input>
                </el-form-item>
                <el-form-item class="form_item" label="备注">
                  <el-input type="textarea" :disabled="disabled" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                    v-model="form.remark"></el-input>
                </el-form-item>
              </el-row>
              <el-row style="background:#fff;padding:15px 0;">
                <el-col :span="12">
                  <el-form-item class="form_item" label="订车合同/协议(最多三张)" prop="images1">
                    <Upload ref="upload1" v-model="form.images1" :disabled="disabled"></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="form_item" label="交易凭证">
                    <Upload ref="upload2" v-model="form.images2" :disabled="disabled"></Upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="7" style="margin-left:20px">
          <div class="title">订单操作记录</div>
          <el-row style="min-height:196px;background:#fff">
            <el-timeline style="margin-top:15px;margin-left:30px">
              <el-timeline-item v-for="(item, index) in timelines" :key="index" color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')">
                <div class="boxLine">
                  <div class="title">{{ item.orderStatus | orderStatus }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { modelOptionalsKeyMap } from './constants.js'
import Upload from "@/components/common/Upload.vue";
import { orderStatusDics } from './constants.js'
import locked from '../../assets/img/locked.svg'
import unlocked from '../../assets/img/unlocked.svg'
var order_vm;
export default {
  components: { Upload },
  data() {
    const validateIdentifyNo = (rule, value, callback) => {
      //15位和18位身份证号码的正则表达式
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(value)) {
        if (value.length == 18) {
          var idCardWi = new Array(
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
          ); //将前17位加权因子保存在数组里
          var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
          var idCardLast = value.substring(17); //得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          } else {
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          }
        }
      } else {
        callback(new Error("请输入合法证件号"));
      }
    };
    const validateReplacedCarNum = (rule, value, callback) => {
      if (this.form.isReplace) {
        var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
        var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
        if (value.length == 7) {
          if (creg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else if (value.length == 8) {
          if (xreg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else {
          callback(new Error("请输入正确车牌号"));
        }
      }
    };
    const validatePhTelNumber = (rule, value, callback) => {
      const telNumber = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!telNumber.test(value)) {
        callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    order_vm = this;
    return {
      locked,
      unlocked,
      modelOptionalsKeyMap,
      initialIndex: 0,
      dealer: this.$common.getLoginInfo().profile,
      orderId: Number(this.$route.query.id),
      formName: sessionStorage.getItem("form"),
      active: 1,
      form: {
        otdStatus: "",
        orderType: "",
        modelId: [],
        modelColor: "",
        paymentDown: "",
        payType: 2,
        customerType: 1,
        customerName: "",
        customerPhone: "",
        identifyType: 1,
        identifyNo: "",
        identifyNos: "",
        identifyNo2: "",
        identifyNo3: "",
        customerAddress: "",
        // address: [],
        deliverDate: "",
        // isReport: true,
        nextFollowDate: "",
        remark: "",
        // mortgagePayment: '',
        images1: [],
        images2: [],
        customerProvince: "",
        customerCity: "",
        customerCounty: "",
        extOrderId: "",
        carInternalColor: '',
        carModelOptionals: {
          optional1: "",
          optional2: "",
          optional3: "",
          optional4: "",
          optional5: "",
          optional6: "",
          optional7: "",
          optional8: "",
          optional9: "",
        }, // 车型选装
        orderReason: [],
        competeSeriesId: '',
        businessType: '', // 购车类型
      },
      formRules: {
        contractNo: [
          {
            required: true,
            message: "请输入合同编号",
            trigger: "blur",
          },
        ],
        orderType: [
          {
            required: true,
            message: "请选择订单类型",
            trigger: "blur",
          },
        ],
        modelId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur",
          },
        ],
        modelColor: [
          {
            required: true,
            message: "请选择外观颜色",
            trigger: "blur",
          },
        ],
        carInternalColor: [
          {
            required: true,
            message: "请选择内饰",
            trigger: "blur",
          },
        ],
        isSanbao: [
          {
            required: true,
            message: "请选择是否三包车",
            trigger: "blur",
          },
        ],
        paymentDown: [
          {
            required: true,
            message: "请输入订金",
            trigger: "blur",
          },
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "blur",
          },
        ],
        paymentDeal: [
          {
            required: true,
            message: "请输入成交金额",
            trigger: "blur",
          },
        ],
        vehiclePurpose: [
          {
            required: true,
            message: "请选择车辆用途",
            trigger: "blur",
          },
        ],
        isReplace: [
          {
            required: true,
            message: "请选择是否置换",
            trigger: "blur",
          },
        ],
        replacedCarNum: [
          {
            required: true,
            validator: validateReplacedCarNum,
            trigger: "blur",
          },
        ],
        secondDealerName: [
          {
            required: true,
            message: "请输入二级店名",
            trigger: "blur",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "blur",
          },
        ],
        customerName: [
          {
            required: true,
            message: "请输入订车人姓名",
            trigger: "blur",
          },
        ],
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur",
          },
        ],
        identifyNo: [
          {
            required: true,
            validator: validateIdentifyNo,
            trigger: "blur",
          },
        ],
        identifyNo2: [
          {
            required: true,
            // validator: validateIdentifyNo2,
            message: "请输入护照",
            trigger: "blur",
          },
        ],
        identifyNo3: [
          {
            required: true,
            message: "请输入合法军官证件号",
            trigger: "blur",
          },
        ],
        identifyNos: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
        ],
        customerPhone: [
          {
            required: true,
            validator: validatePhTelNumber,
            trigger: "blur",
          },
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择预计交车时间",
            trigger: "blur",
          },
        ],
        businessType: [
          {
            required: true,
            message: "请选择购车类型",
            trigger: "blur",
          },
        ],
        nextFollowDate: [
          {
            required: true,
            message: "请选择下次跟进时间",
            trigger: "blur",
          },
        ],
        images1: [
          {
            required: true,
            message: "请上传合同/协议",
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      orderTypeDics: [], // 订单类型
      orderIdentifyTypeDics: [], // 证件类型
      businessTypeOptions: [], // 购车类型
      orderStatusDics, // 操作记录标题
      carOptions: [], // 订购车型
      colors: [], //车辆颜色
      vins: [], // 车架号
      timelines: [],
      disabled: true,
      customer: {},
      data: {},
      provinces: [],
      citys: [],
      countys: [],
      carInternalColor: [],
      carModelOptionalsMaps: {},
      failProductReasonDics: [],
      competitionSeries: [],
      customerOrder: {}
    };
  },
  computed: {
    isEditing() {
      return this.disabled === false
    },
    carModelOptionalsComputed() {
      let value = {}
      for (const key in this.carModelOptionalsMaps) {
        if(Object.prototype.hasOwnProperty.call(this.carModelOptionalsMaps, key) && this.carModelOptionalsMaps[key] && this.carModelOptionalsMaps[key].some(Boolean)) {
          value[key] = this.carModelOptionalsMaps[key]
          if(this.isEditing && !this.form.carModelOptionals[key]) {
            this.form.carModelOptionals[key] = (value[key][0] === '无选装' ? '' : value[key][0])
          }
        }
      }
      return value
    }
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.orderTypeDics = baseInfo.orderTypeDics;
    this.orderIdentifyTypeDics = baseInfo.orderIdentifyTypeDics;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.failProductReasonDics = baseInfo.failProductReasonDics;
    this.retrieveCarOptions();
    this.getOrder();
    this.getProvinces();
    this.getCompetitionSeriesesOptions();
  },
  methods: {
    // 返回
    back() {
      if (sessionStorage.getItem("form") === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId,
        });
      } else if (sessionStorage.getItem("form") === "order") {
        this.$router.push({
          path: "/order/zzOrder",
        });
      } else {
        this.$router.go(-1);
      }
    },
    getCompetitionSeriesesOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: "",
        })
        .then(res => {
          this.competitionSeries = res.data.data;
        });
    },
    // 省改变
    provinceChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: val,
          city: "",
        })
        .then((res) => {
          this.citys = res.data.data;
          if(isClear) {
            this.form.customerCity = "";
            this.form.customerCounty = "";
          }
        });
    },
    // 市改变
    cityChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: this.form.customerProvince,
          city: val,
        })
        .then((res) => {
          this.countys = res.data.data;
          if(isClear) {
            this.form.customerCounty = "";
          }
        });
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: "",
        })
        .then((res) => {
          this.provinces = res.data.data;
        });
    },
    
    // 去客户详情
    toCustomer() {
      this.$router.push({
        path: "/customer/detail/" + this.form.customerId,
      });
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    changeSpecColor(val) {
      this.form.modelColor = "";
      this.colors = [];
      this.form.carInternalColor = ''
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getVehicleColor(val)
    },
    getVehicleColor(val) {
      const modelId = val[1];
      this.$httpAuth
        .post("/v2/appCustomerService/vehicleColor", {
          modelId: parseInt(modelId),
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.colors = response.data.data;
        })
        .catch(() => { });
    },
    // 获取订单详情
    getOrder() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderDetail", {
          orderId: this.orderId,
          dealerId: this.dealer.dealerId,
        })
        .then(function (res) {
          let data = res.data;
          if(data && data.order.status == 8) {
            that.$router.replace({
              path: "/cancel",
              query: { id: that.orderId }
            });
          }
          that.data = res.data;
          that.customerOrder = res.data.order
          that.timelines = that.data.timelines;
          let orderReason =  []
          if (that.data.purchaseInfo&&that.data.purchaseInfo.orderReason != '') {
            orderReason = that.data.purchaseInfo.orderReason.split(',')
          }
          const competeSeriesId = that.data.purchaseInfo && that.data.purchaseInfo.competeSeriesId?that.data.purchaseInfo.competeSeriesId:''
          const { carInternalColor = '', carColor, choicePackage1Name, choicePackage2Name,
            choicePackage3Name, choicePackage4Name, choicePackage5Name, choicePackage6Name, choicePackage7Name, 
            choicePackage8Name, choicePackage9Name
           } = data.carInfo || {}
          that.form = {
            referrerName: data.order.referrerName || '无',
            referrerPhone: data.order.referrerPhone || '无',
            otdStatus: that.data.order.otdStatus,
            extOrderId: that.data.order.extOrderId,
            customerId: that.data.order.customerId,
            // contractNo: that.data.order.contractNo,
            orderType: that.data.order.orderType || "",
            modelId: [],
            modelColor: carColor || that.data.order.modelColor,
            carInternalColor: carInternalColor,
            carModelOptionals: {
              optional1: choicePackage1Name,
              optional2: choicePackage2Name,
              optional3: choicePackage3Name,
              optional4: choicePackage4Name,
              optional5: choicePackage5Name,
              optional6: choicePackage6Name,
              optional7: choicePackage7Name,
              optional8: choicePackage8Name,
              optional9: choicePackage9Name,
            }, // 车型选装
            // modelVin: that.data.order.modelVin,
            // isSanbao: that.data.order.isSanbao,
            paymentDown: that.data.order.paymentDown,
            payType: that.data.order.payType,
            // paymentFirst: that.data.order.paymentFirst,
            // paymentYears: that.data.order.paymentYears,
            // paymentDeal: that.data.order.paymentDeal,
            // paymentOther: that.data.order.paymentOther,
            // mortgagePayment: that.data.order.mortgagePayment,
            // vehiclePurpose: that.data.order.vehiclePurpose,
            // isReplace: that.data.order.isReplace,
            customerType: that.data.order.customerType,
            customerName:
              that.data.order.customerType === 1
                ? that.data.order.customerName
                : that.data.order.companyName,
            customerPhone: that.data.order.customerPhone,
            identifyType: that.data.order.identifyType,
            identifyNo: that.data.order.identifyNo,
            identifyNos: that.data.order.identifyNo,
            identifyNo2: that.data.order.identifyNo,
            identifyNo3: that.data.order.identifyNo,
            customerAddress: that.data.order.customerAddress,
            deliverDate: that.data.order.deliverDate ? that.data.order.deliverDate * 1000 : '',
            // isReport: that.data.order.isReport,
            remark: that.data.order.remark,
            // isOtherDealer: that.data.order.isOtherDealer,
            // replacedCarNum: that.data.order.replacedCarNum,
            // isSaledBySecond: that.data.order.isSaledBySecond,
            // secondDealerName: that.data.order.secondDealerName,
            nextFollowDate: "",
            customerProvince: that.data.order.customerProvince,
            customerCity: that.data.order.customerCity,
            customerCounty: that.data.order.customerCounty,
            images1: [],
            images2: [],
            orderReason,
            competeSeriesId,
            reactivateSource: that.data.reactivateSource || '',
            sourceName: that.data.sourceName || '',
            businessType: that.data.order.businessType || '',
          };
          if (that.data.order.customerProvince != '') {
            that.provinceChange(that.data.order.customerProvince, false);
          }
          if (that.data.order.customerCity) {
            that.cityChange(that.data.order.customerCity, false);
          }
          setTimeout(() => {
            that.form.customerCity = that.data.order.customerCity;
            that.form.customerCounty = that.data.order.customerCounty;
          }, 300);
          if (that.data.order.images1 != "") {
            that.form.images1 = that.data.order.images1.split(",")
          }
          if (that.data.order.images2 != "") {
            that.form.images2 = that.data.order.images2.split(",")
          }
          that.getmodelId(that.data.order.modelId);
          that.geCustomerInfo();
        })
        .catch(() => { });
    },
    getmodelId(id) {
      var that = this;
      this.$httpAuth
        .post("/v1/baseRpc/getSpec", {
          id: id,
        })
        .then(function (res) {
          that.form.modelId = [
            res.data.spec.seriesId + "",
            res.data.spec.id + "",
          ];
          that.getVehicleColor(that.form.modelId);
          that.form.modelColor = that.data.carInfo ? that.data.carInfo.carColor : that.data.order.modelColor;
          // that.form.carInternalColor = res.data.spec.carInternalColor;
          that.getCarModelDetail();
          that.getCarModelOptionals()
        })
        .catch(() => { });
    },
    getCarModelDetail() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelDetail", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carWheelBoss: '',
          carWheel: '',
          carInternalColor: this.form.carInternalColor,
        }).then(res => {
          this.carInternalColor = [...res.data.carInternalColor];
          if(this.isEditing && this.carInternalColor && this.carInternalColor[0]) {
            this.form.carInternalColor = this.carInternalColor[0]
            this.getCarModelOptionals()
          }
          const isHasInternalColor = this.carInternalColor.some(Boolean)
          if(!isHasInternalColor) {
            this.getCarModelOptionals()
          }
        })
    },
    getCarModelOptionals() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelOptionals", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carModelOptionalsMaps = res.data;
        });
    },
    modelColorChange() {
      this.form.carInternalColor = ''
      this.getCarModelDetail();
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
    },
    carInternalColorChange() {
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelOptionals()
    },
    geCustomerInfo() {
      this.$httpAuth
        .post("/v2/appCustomerService/get", {
          dealerId: this.dealer.dealerId,
          customerId: this.form.customerId,
        })
        .then((res) => {
          this.customer = { ...res.data.customer };
        });
    },
    customerTypeChange(val) {
      if (val === 1) {
        this.form.customerName = this.customer.name;
      } else {
        this.form.customerName = this.customer.companyName;
      }
    },
    identifyTypeChange() {
      this.form.identifyNo = "";
      this.form.identifyNo2 = "";
      this.form.identifyNo3 = "";
      this.form.identifyNos = "";
    },
  },
  filters: {
    orderStatus(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i];
        if (o.orderStatus == val) {
          return o.name;
        }
      }
      return "";
    },
  },
};
</script>
<style scoped>
.back {
  font-size: 14px;
}

.el-step__title {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.boxLine {
  width: 250px;
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLine .title {
  font-weight: 600;
  color: #000;
}

.el-timeline-item__wrapper {
  position: relative;
}

.el-timeline-item__timestamp {
  position: absolute;
  left: -110px;
  top: 0;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}

.hide .el-upload--picture-card {
  display: none;
}

.el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}

.el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
}
</style>
